import { useCallback, useState } from "react";
import { clearBrowserStorage } from "../utils/clearBrowserStorage";

export const useClearStorage = () => {
	const [isLoading, setLoading] = useState(false);

	const clearStorage = useCallback(() => {
		setLoading(true);
		clearBrowserStorage();

		window.location.reload();
	}, []);

	return { clearStorage, isLoading };
};
